import API from '@/API/API'

const ConfirmEmailStore = {
  api: API,
  state: {
    currentUserId: '',
    message:''
  },
  reset:function() {
    this.state = {
      currentUserId: '',
      favorites: [],
      loadedFavorites: false
    }
  },
  confirmEmail: function(token,success,error,maintenance){
    let self = this;
    this.api
    .confirmEmail(token)
    .then(function (res) {
      self.state.loadedFavorites = true
      if (res.data) {
        let data = res.data
        if (data.error) {
          self.state.message = data.error
          success()
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            self.state.message = data.message
            success()
        }
      }else{
        self.state.message = "Failed to confirm email"
      }
    })
    .catch(e => {
      error('An Error Occurred')
      self.state.loadedFavorites = true
    })
  }
}

export default ConfirmEmailStore



// WEBPACK FOOTER //
// ./src/components/account/ConfirmEmailStore.js